import React from 'react';
import LoginForm from '../components/auth/LoginForm';

const LoginPage: React.FC = () => {
  return (
    <div className="auth-page">
      {/* Grid Overlay */}
      <div className="grid-overlay"></div>
      
      {/* Horizon Line */}
      <div className="horizon"></div>
      
      {/* Data Streams */}
      <div className="data-streams">
        <div className="data-stream"></div>
        <div className="data-stream"></div>
        <div className="data-stream"></div>
        <div className="data-stream"></div>
      </div>
      
      {/* Detective Investigation Scene */}
      <div className="investigation-scene">
        <div className="magnifying-glass">
          <div className="ar-crosshair"></div>
        </div>
        <div className="evidence-board">
          <div className="evidence-pins"></div>
          <div className="evidence-strings"></div>
        </div>
        <div className="data-nodes">
          <div className="data-node data-node-1"></div>
          <div className="data-node data-node-2"></div>
          <div className="data-node data-node-3"></div>
          <div className="data-node data-node-4"></div>
          <div className="data-node data-node-5"></div>
          <div className="data-node data-node-6"></div>
          <div className="connection-lines">
            <div className="connection-line connection-line-1"></div>
            <div className="connection-line connection-line-2"></div>
            <div className="connection-line connection-line-3"></div>
            <div className="connection-line connection-line-4"></div>
            <div className="connection-line connection-line-5"></div>
            <div className="connection-line connection-line-6"></div>
          </div>
        </div>
        <div className="binary-stream">
          <div className="binary-digit">1</div>
          <div className="binary-digit">0</div>
          <div className="binary-digit">1</div>
          <div className="binary-digit">0</div>
          <div className="binary-digit">1</div>
          <div className="binary-digit">0</div>
          <div className="binary-digit">1</div>
        </div>
        <div className="binary-stream-left">
          <div className="binary-digit">0</div>
          <div className="binary-digit">1</div>
          <div className="binary-digit">0</div>
          <div className="binary-digit">1</div>
          <div className="binary-digit">0</div>
        </div>
      </div>
      
      <div className="auth-container">
        <LoginForm />
      </div>
    </div>
  );
};

export default LoginPage; 